var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91747 7.33333H2.83329V5.66667C2.83329 3.36548 4.69877 1.5 6.99996 1.5C9.30115 1.5 11.1666 3.36548 11.1666 5.66667V7.33333H11.0824M6.99996 10.6667V12.3333M12.8333 11.5C12.8333 14.7217 10.2216 17.3333 6.99996 17.3333C3.7783 17.3333 1.16663 14.7217 1.16663 11.5C1.16663 8.27834 3.7783 5.66667 6.99996 5.66667C10.2216 5.66667 12.8333 8.27834 12.8333 11.5Z",
    stroke: "#081D3F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/Secure.2d45fb3d5b0f5341c95f762301b95574.svg";
export { ForwardRef as ReactComponent };